import { ComponentProps, FC } from 'react';

import classNames from 'classnames';

export const Description: FC<ComponentProps<'div'>> = ({ className, ...rest }) => (
    <div className={classNames('description', className)} {...rest} />
);
